














import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class MultipleSelector extends Vue {
  checked = []
  watch = false
  $refs: any

  @Prop({ type: String, default: null }) position: string
  @Prop({ type: Array, default: () => null }) items: []
  @Prop({ type: Array, default: () => null }) availables: []
  @Prop({ type: Boolean, default: false }) full: boolean

  @Watch('checked')
  emitCheckedItems(checked) {
    if (this.watch) {
      this.$emit('change', checked)
    }
  }

  get checkedLabels() {
    return this.availables
      ? this.availables.reduce((acc, val) => {
        // @ts-ignore
        if (this.checked.includes(val.value)) {
          // @ts-ignore
          acc.push(val.label)
        }
        return acc
      }, [])
      : null
  }

  get placeholder() {
    return this.checked && this.checked.length > 0
      ? this.checkedLabels.join(', ')
      : this.$t('global.dropdown.placeholder')
  }

  get placeholderClass() {
    return this.checked && this.checked.length > 0 ? 'has-text-dark' : 'has-text-gray'
  }

  change(item) {
    this.$emit('change', item)
  }

  created() {
    this.watch = false
    if (this.items && this.items.length > 0) {
      this.items.forEach((item) => {
        this.checked.push(item)
      })
    }
    setTimeout(() => this.watch = true, 200)
  }

  closeDropdown() {
    this.$refs.dropdown.toggle()
  }

  init() {
    this.checked = []
    this.closeDropdown()
  }
}
